import { createSlice } from '@reduxjs/toolkit';
import { resetStateBetweenCallObjects } from '../app/actions';
import { getMeetingParticipants, getMeetingParticipantsFromBackend, mapParticipantToContact, saveMeetingParticipants, setParticipants } from './actions';
const initialState = {
  participants: [],
  isLoading: false,
  isGoogleOutage: false
};
const participants = createSlice({
  name: 'participants',
  initialState,
  reducers: {
    setIsGoogleOutage: (state, action) => {
      state.isGoogleOutage = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(resetStateBetweenCallObjects.type, state => {
      state.participants = [];
    });
    builder.addCase(setParticipants.type, (state, action) => {
      state.isLoading = false;
      state.participants = action.payload.map(participant => {
        const existingParticipant = state.participants.find(item => item.participantId === participant.participantId);
        if (existingParticipant) {
          const newParticipant = Object.assign({}, existingParticipant, participant);
          return newParticipant;
        }
        return participant;
      });
    });
    builder.addCase(getMeetingParticipantsFromBackend.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(mapParticipantToContact.fulfilled, (state, action) => {
      const participantToModifyIndex = state.participants.findIndex(participant => participant.participantId === action.payload.participantId);
      let modifiedParticipants = [...state.participants];
      if (participantToModifyIndex > -1) {
        modifiedParticipants = [...state.participants.slice(0, participantToModifyIndex), Object.assign({}, state.participants[participantToModifyIndex], {
          contact: action.payload.contact
        }), ...state.participants.slice(participantToModifyIndex + 1)];
      }
      state.participants = modifiedParticipants;
    });
    builder.addCase(getMeetingParticipants.rejected, (state, action) => {
      var _action$meta$arg;
      state.isLoading = false;
      state.isGoogleOutage = !((_action$meta$arg = action.meta.arg) !== null && _action$meta$arg !== void 0 && _action$meta$arg.intervalFetchAction);
    });
    builder.addCase(getMeetingParticipants.pending, (state, action) => {
      var _action$meta$arg2;
      state.isLoading = !((_action$meta$arg2 = action.meta.arg) !== null && _action$meta$arg2 !== void 0 && _action$meta$arg2.intervalFetchAction);
    });
    builder.addCase(getMeetingParticipantsFromBackend.fulfilled, state => {
      state.isLoading = false;
    });
    builder.addCase(getMeetingParticipantsFromBackend.rejected, state => {
      state.isLoading = false;
      state.participants = [];
    });
    builder.addCase(saveMeetingParticipants.rejected, state => {
      state.isLoading = false;
      state.participants = [];
    });
  }
});
export const participantsActions = participants.actions;
export default participants.reducer;